import React, { useEffect, useRef } from "react";
import useOnClickOutside from "../../../hooks/useClickOutside/useClickOutside";
import "./menuFlottant.scss";

// Menu flottant sous un bouton : le focus entre dans le menu à l'ouverture,
// Échap referme et rend le focus au bouton, les flèches haut et bas passent
// d'une entrée à l'autre, un clic hors du menu referme.
const MenuFlottant = ({ ouvert, onFermer, refBouton, aligne = "droite", titre, role = "menu", largeur, children }) => {
  const ref = useRef(null);

  useOnClickOutside(ref, (evenement) => {
    if (!ouvert) return;
    if (refBouton && refBouton.current && refBouton.current.contains(evenement.target)) return;
    onFermer();
  });

  useEffect(() => {
    if (!ouvert || !ref.current) return;
    const premier = ref.current.querySelector('input, [role^="menuitem"]:not([disabled])');
    if (premier) premier.focus();
  }, [ouvert]);

  if (!ouvert) return null;

  const surClavier = (evenement) => {
    if (evenement.key === "Escape") {
      evenement.preventDefault();
      evenement.stopPropagation();
      onFermer();
      if (refBouton && refBouton.current) refBouton.current.focus();
      return;
    }
    if (evenement.key === "ArrowDown" || evenement.key === "ArrowUp") {
      const entrees = Array.from(ref.current.querySelectorAll('[role^="menuitem"]:not([disabled]):not([hidden])'));
      if (!entrees.length) return;
      const i = entrees.indexOf(document.activeElement);
      const j = evenement.key === "ArrowDown" ? Math.min(entrees.length - 1, i + 1) : Math.max(0, i - 1);
      entrees[j].focus();
      evenement.preventDefault();
    }
  };

  return (
    <div
      ref={ref}
      className={`la-menu la-menu--${aligne}`}
      role={role}
      aria-label={titre}
      onKeyDown={surClavier}
      style={largeur ? { width: largeur } : undefined}
    >
      {titre && (
        <div className="la-menu__titre" aria-hidden="true">
          {titre}
        </div>
      )}
      {children}
    </div>
  );
};

export default MenuFlottant;
